import React, { FunctionComponent } from 'react';
import { logout } from '@/utility/auth/authWrapper';
import useCurrentUser from '@jetslash/market-frontend-shared-core/src/hooks/useCurrentUser';

interface IProps {}

const StartOverButton: FunctionComponent<IProps> = () => {
  const { clearCurrentUser } = useCurrentUser();

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href="#"
      onClick={() => {
        clearCurrentUser();
        logout();
      }}
    >
      Start over
    </a>
  );
};

export default StartOverButton;
